function ServiceCards() {
  const cards = document.querySelectorAll(".serviceCards__card");
  if (!cards.length) return;
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  cards.forEach((card) => {
    let frame = null;
    let pointerX = 0;
    let pointerY = 0;

    card.addEventListener("pointermove", (event) => {
      pointerX = event.clientX;
      pointerY = event.clientY;
      if (frame) return;
      frame = requestAnimationFrame(() => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty("--mx", `${pointerX - rect.left}px`);
        card.style.setProperty("--my", `${pointerY - rect.top}px`);
        frame = null;
      });
    });
  });
}

export default ServiceCards;
